import React, { useState } from 'react'
import {Checkbox, Form , Spin} from 'antd'
import { useAllowSalesPersonLogin } from '../../services/settings'


function Settings(){
    const { allowSalesPersonLogin , isLoading, setAllowSalesPersonLogin } = useAllowSalesPersonLogin()

    return < Spin spinning={isLoading}>    
        <Form>
            <Form.Item  labelCol={{span:6}} wrapperCol={{span:6 , offset:3}} label="Allow sales persons to login">
                <Checkbox  onChange={e => setAllowSalesPersonLogin(e.target.checked)}  checked={allowSalesPersonLogin} />
            </Form.Item>
        </Form>
    </Spin>
}

export default Settings